import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

//* Environments
import { environment } from 'src/environments/environment';

//* Interfaces
import {
	CommunityOrganization,
	CycleAndGrade,
	EducationLevel,
	KnowledgeArea,
	Labpoint,
	ManagementCategory,
	PopulationGroup,
	SchoolGovernanceBody,
	SchoolShift,
	Subject,
	ThematicArea
} from '../interfaces/core/common.entity';

@Injectable({ providedIn: 'root' })
export class CommonService {
	private gatewayURL: string = environment.gatewayURL;

	constructor(private http: HttpClient) {}

	getCommunityOrganizations(): Observable<CommunityOrganization[]> {
		return this.http
			.get<{
				data: CommunityOrganization[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/community-organizations`)
			.pipe(map((response) => response.data));
	}

	getCyclesAndGrades(): Observable<CycleAndGrade[]> {
		return this.http
			.get<{
				data: CycleAndGrade[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/cycles-and-grades`)
			.pipe(map((response) => response.data));
	}

	getEducationalLevels(): Observable<EducationLevel[]> {
		return this.http
			.get<{
				data: EducationLevel[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/education-levels`)
			.pipe(map((response) => response.data));
	}

	getKnowledgeAreas(): Observable<KnowledgeArea[]> {
		return this.http
			.get<{
				data: KnowledgeArea[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/knowledge-areas`)
			.pipe(map((response) => response.data));
	}

	getLabpoints(): Observable<Labpoint[]> {
		return this.http
			.get<{
				data: Labpoint[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/labpoints`)
			.pipe(map((response) => response.data));
	}

	getManagementCategories(): Observable<ManagementCategory[]> {
		return this.http
			.get<{
				data: ManagementCategory[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/management-categories`)
			.pipe(map((response) => response.data));
	}

	getPopulationGroups(): Observable<PopulationGroup[]> {
		return this.http
			.get<{
				data: PopulationGroup[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/population-groups`)
			.pipe(map((response) => response.data));
	}

	getSchoolGovernanceBodies(): Observable<SchoolGovernanceBody[]> {
		return this.http
			.get<{
				data: SchoolGovernanceBody[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/school-governance-bodies`)
			.pipe(map((response) => response.data));
	}

	getSchoolShifts(): Observable<SchoolShift[]> {
		return this.http
			.get<{
				data: SchoolShift[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/school-shifts`)
			.pipe(map((response) => response.data));
	}

	getSubjects(): Observable<Subject[]> {
		return this.http
			.get<{
				data: Subject[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/school-shifts`)
			.pipe(map((response) => response.data));
	}

	getThematicAreas(): Observable<ThematicArea[]> {
		return this.http
			.get<{
				data: ThematicArea[];
				total: number;
			}>(`${this.gatewayURL}/v1/common/thematic-areas`)
			.pipe(map((response) => response.data));
	}
}
